var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.627 15.6797L15.3714 13.5073L11.627 11.3242V15.6797Z",
    fill: "#F6901F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C10.83 0 8.21987 0.791761 5.99981 2.27516C3.77974 3.75856 2.04941 5.86697 1.02763 8.33377C0.0058493 10.8006 -0.261496 13.515 0.259405 16.1337C0.780305 18.7525 2.06605 21.1579 3.95406 23.0459C5.84207 24.9339 8.24754 26.2197 10.8663 26.7406C13.485 27.2615 16.1994 26.9941 18.6662 25.9724C21.133 24.9506 23.2414 23.2203 24.7248 21.0002C26.2082 18.7801 27 16.17 27 13.5C27 9.91957 25.5777 6.4858 23.0459 3.95406C20.5142 1.42232 17.0804 0 13.5 0ZM20.6053 15.8891C20.6055 16.2422 20.5362 16.5919 20.4012 16.9182C20.2662 17.2444 20.0683 17.5409 19.8187 17.7907C19.5691 18.0404 19.2728 18.2386 18.9466 18.3737C18.6204 18.5089 18.2708 18.5785 17.9177 18.5785H9.08231C8.72922 18.5785 8.37959 18.5089 8.05341 18.3737C7.72722 18.2386 7.43087 18.0404 7.18128 17.7907C6.9317 17.5409 6.73377 17.2444 6.59881 16.9182C6.46385 16.5919 6.39451 16.2422 6.39474 15.8891V11.1109C6.39451 10.7578 6.46385 10.4081 6.59881 10.0818C6.73377 9.75554 6.9317 9.45906 7.18128 9.20931C7.43087 8.95956 7.72722 8.76143 8.05341 8.62626C8.37959 8.49109 8.72922 8.42151 9.08231 8.42151H17.9177C18.2708 8.42151 18.6204 8.49109 18.9466 8.62626C19.2728 8.76143 19.5691 8.95956 19.8187 9.20931C20.0683 9.45906 20.2662 9.75554 20.4012 10.0818C20.5362 10.4081 20.6055 10.7578 20.6053 11.1109V15.8891Z",
    fill: "#F6901F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/Color.04466efd4e18ce3235fd6c1c7a3443c0.svg";
export { ForwardRef as ReactComponent };